var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UploadCSV'),_c('iframe',{attrs:{"name":"hiddenframe","hidden":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }